/**
 * @deprecated Use `ControlType` and `Priority` enums instead.
 */
var Type;
(function (Type) {
  Type["PRIMARY"] = "primary";
  /**
   * @deprecated use
   */
  Type["PAY"] = "pay";
  Type["SECONDARY"] = "secondary";
  Type["DANGER"] = "danger";
  Type["LINK"] = "link";
})(Type || (Type = {}));

export { Type };
//# sourceMappingURL=type.mjs.map
